import { useEffect, useRef } from "react";

import { RichTextWidgetConfiguration } from "@/lib/api";

const RichText = ({ configuration }: { configuration: RichTextWidgetConfiguration }) => {
  const contentRef = useRef<HTMLDivElement>(null);

  // add target blank to all links in content
  useEffect(() => {
    if (!contentRef.current) return;
    const links = contentRef.current.querySelectorAll<HTMLAnchorElement>("a");
    links.forEach((link) => {
      if (link.href) {
        link.setAttribute("target", "_blank");
      }
    });
  }, [configuration.content, contentRef]);

  return (
    <div
      ref={contentRef}
      className="lexical-result"
      dangerouslySetInnerHTML={{
        __html: configuration.content,
      }}
    />
  );
};

export default RichText;
